const channelType = {
	amazon: 'Amazon',
	overstock: 'Overstock',
	walmart: 'Walmart',
	wooCommerce: 'WooCommerce',
	costco: 'Costco',
	buybuyBaby: 'Buy Buy Baby',
	mattressFirm: 'Mattress Firm',
	homeDepot: 'Home Depot',
	wayfair: 'Wayfair',
	overstockCA: 'Overstock CA',
	logicBroker: 'LogicBroker',
	mirakl: 'Mirakl',
	shopify: 'Shopify',
	amazonVendor: 'Amazon Vendor',
	sellerCloud: 'SellerCloud',
	manualOrders: 'Manual Orders',
	goFlow: 'GoFlow',
	shipStation: 'ShipStation',
};

// ShipStation brokers its own carriers, Amazon Vendor ships on Amazon's, so neither uses Scanship carriers.
const channelTypesWithoutRequiredCarriers = [channelType.amazonVendor, channelType.shipStation];

export { channelType, channelTypesWithoutRequiredCarriers };
